import {
    Box,
    Button,
    Image,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Link as StyledLink,
    Table,
    Tag,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MdAdd, MdSettings } from "react-icons/md";
import { useParams } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { ICreateStoryItemFormValues, StoryItemForm } from "../../forms";
import {
    StoriesDocument,
    StoryDocument,
    StoryItem,
    StoryItemType,
    useCreateStoryItemMutation,
    useDeleteStoryItemMutation,
    useStoryQuery,
    useUpdateStoryItemMutation
} from "../../graphql";
import { useDashboardTitle } from "../../hooks/useDashboardTitle";
import { formatDateTime } from "../../utils";

const StoryItems: React.FC = () => {
    const { id } = useParams<{
    id: string;
  }>();
    const storyId = parseInt(id);
    const { setTitle } = useDashboardTitle();
    const [currentItem, setCurrentItem] = useState<StoryItem>();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { data, loading } = useStoryQuery({
        variables: {
            id: storyId,
            iconWidth: 100
        }
    });
    const [create] = useCreateStoryItemMutation();
    const [update] = useUpdateStoryItemMutation();
    const [deleteItem] = useDeleteStoryItemMutation();

    useEffect(() => {
        if (!loading) {
            setTitle([
                {
                    to: "/stories",
                    text: "Bllokmedia"
                },
        data?.story?.title
            ]);
        }
    // eslint-disable-next-line
  }, [loading]);

    const handleCreatEvent = async (data: ICreateStoryItemFormValues) => {
        currentItem
            ? await update({
                variables: {
                    id: currentItem.id,
                    mediaKey: data.media.key,
                    linkLabel: data.linkLabel,
                    isActive: data.isActive === "1",
                    bgColor: data.bgColor,
                    storyId: storyId,
                    linkURL: data.linkURL,
                    language: data.languageCode
                },
                refetchQueries: [
                    {
                        query: StoryDocument,
                        variables: {
                            id: storyId,
                            iconWidth: 100
                        }
                    }
                ]
            })
            : await create({
                variables: {
                    mediaKey: data.media.key,
                    linkLabel: data.linkLabel,
                    isActive: data.isActive === "1",
                    bgColor: data.bgColor,
                    storyId: storyId,
                    linkURL: data.linkURL,
                    language: data.languageCode
                },
                refetchQueries: [
                    {
                        query: StoryDocument,
                        variables: {
                            id: storyId,
                            iconWidth: 100
                        }
                    }
                ]
            });

        onClose();

        setCurrentItem(null);
    };

    const handleDeleteEvent = async (id: number) => {
        await deleteItem({
            variables: {
                id: id
            },
            refetchQueries: [
                {
                    query: StoryDocument,
                    variables: {
                        id: storyId,
                        iconWidth: 100
                    }
                }
            ]
        });

        onClose();
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <Modal
                closeOnOverlayClick={ false }
                isOpen={ isOpen }
                onClose={ onClose }
                size="xl"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Shto një faqe në bllokmedia</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <StoryItemForm
                            onSubmit={ (data) => {
                                handleCreatEvent(data);
                            } }
                            initialValues={ {
                                media: currentItem?.media,
                                isActive: currentItem?.isActive ? "1" : "0",
                                linkLabel: currentItem?.linkLabel,
                                bgColor: currentItem?.bgColor,
                                storyId: storyId,
                                linkURL: currentItem?.linkURL,
                                languageCode: currentItem?.language.code
                            } }
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Title title={ `Faqet e bllokmedias "${data?.story?.title}"` }>
                    <Button
                        rightIcon={ <MdAdd /> }
                        colorScheme="blue"
                        variant="outline"
                        size="sm"
                        onClick={ onOpen }
                    >
                        Shto
                    </Button>
                </Title>

                <Table variant="striped" size="sm">
                    <Thead>
                        <Tr>
                            <Th>Titulli</Th>
                            <Th>Gjuha</Th>
                            <Th>Skedari</Th>
                            <Th>Dërgon në</Th>
                            { /* <Th>Numri i faqeve</Th> */ }
                            <Th>Sfondi</Th>
                            <Th>Statusi</Th>
                            <Th>Autori</Th>
                            <Th>Ndryshimi i fundit</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        { data?.story?.items?.map((item) => (
                            <Tr key={ item.id }>
                                <Td>{ item.linkLabel }</Td>
                                <Td>{ item.language.name }</Td>
                                <Td>
                                    { item.media.url ? (
                                        <StyledLink>
                                            <a target="blank" href={ item.media.url }>
                                                { item.type === StoryItemType.Video ? "Video" : "Foto" }
                                            </a>
                                        </StyledLink>
                                    ) : (
                                        ""
                                    ) }
                                </Td>
                                { /* <Td>
                  {item.type === StoryItemType.Video ? (
                    "Shkarko videon"
                  ) : (
                    <Image
                      // border={"2px solid #205aa7"}
                      borderRadius="full"
                      boxSize="50px"
                      src={item.media.url}
                      alt={item.linkLabel}
                    />
                  )}
                </Td> */ }
                                { /* <Td>{item.items.length}</Td> */ }
                                <Td>
                                    { item.linkURL ? (
                                        <StyledLink>
                                            <a target="blank" href={ item.linkURL }>
                                                { `${item.linkURL.slice(0, 35)}...` }
                                            </a>
                                        </StyledLink>
                                    ) : (
                                        ""
                                    ) }
                                </Td>
                                <Td>
                                    <Box
                                        style={ {
                                            height: "25px",
                                            width: "25px",
                                            backgroundColor: item.bgColor
                                        } }
                                    ></Box>
                                </Td>
                                <Td>
                                    { item.isActive ? (
                                        <Tag colorScheme="green">Aktive</Tag>
                                    ) : (
                                        <Tag colorScheme="gray">Jo aktive</Tag>
                                    ) }
                                </Td>
                                <Td>
                                    <AccountAvatar account={ item.author } role={ false } size="sm" />
                                </Td>
                                <Td>{ formatDateTime(item.updatedAt) }</Td>
                                <Td isNumeric>
                                    <Menu>
                                        <MenuButton
                                            px={ 2 }
                                            py={ 0.5 }
                                            transition="all 0.2s"
                                            _focus={ { boxShadow: "outline" } }
                                        >
                                            <MdSettings />
                                        </MenuButton>
                                        <MenuList>
                                            <MenuItem
                                                onClick={ () => {
                                                    setCurrentItem(item as StoryItem);
                                                    onOpen();
                                                } }
                                            >
                                                Redakto
                                            </MenuItem>
                                            <MenuItem onClick={ () => handleDeleteEvent(item.id) }>
                                                Fshi
                                            </MenuItem>
                                        </MenuList>
                                    </Menu>
                                </Td>
                            </Tr>
                        )) }
                    </Tbody>
                </Table>
            </Box>
        </>
    );
};

export default StoryItems;
